import React from 'react';

const DocumentsNeededList = ({ documents, onDocumentClick, customClass, showBar }) => {
    return (
        <div className="relative">
            <div className={`absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200 dark:bg-gray-700 ${showBar ? '' : 'hidden'}`} />

            {documents.map((doc) => (
                <a
                    key={doc.id}
                    onClick={() => onDocumentClick(doc.id)}
                    className={`block relative  py-2 hover:bg-gray-50 dark:hover:bg-gray-700 rounded transition-colors cursor-pointer
            ${doc.uploaded || doc.have_document === 1 ? 'text-green-600 dark:text-green-400' : 'text-gray-500 dark:text-gray-300'} ${customClass}`}
                >
                    <span className="font-medium">{doc.name || doc.files?.[0]?.file_name}</span>
                    {doc.description && (
                        <p className="text-sm text-gray-500 dark:text-gray-400">{doc.description}</p>
                    )}
                </a>
            ))}
        </div>
    );
};

export default DocumentsNeededList;
